import { createPinia } from "pinia";

// Pinia-инстанс приложения (подключается в main.js через app.use(store)).
//
// NANFin-XXX: раньше здесь было `createPinia({ modules, strict })`, где `modules`
// собирал src/state/modules/index.js жадным require.context'ом по каталогу. Это
// наследство Vuex-шаблона Velzon (в комментарии даже стояла ссылка на доку Vuex):
// createPinia() НЕ принимает ни `modules`, ни `strict` — переданный объект просто
// игнорировался. Сторы в Pinia регистрируются лениво, при первом useXStore(),
// поэтому никакой «регистрации» и не требовалось.
//
// Вреда при этом хватало: require.context импортировал и ВЫПОЛНЯЛ каждый .js из
// src/state/modules/**, затягивая в прод-бандл всё, что там лежит. Так тестовый
// auth.spec.js попал в сборку, выполнил `import { vi } from "vitest"` в браузере и
// уронил приложение на стенде. index.js удалён вместе с этой миной.
const store = createPinia();

export default store;
